import "./FlashSale.css";
import { useHistory } from "react-router-dom";
import images from "../../../../../utilities/images/images";
import { navigateFromUserDashboardBanner } from "../../../../../custom_utilities/dashboardBannerNavigation";

const FlashSale = ({ data }) => {
  const {
    banner_image,
    name,
    package_name,
    package_amount,
    flashsale_message,
    icon,
    button_text,
    package_id,
    amount_message,
  } = data;

  const history = useHistory();
  return (
    <div className="flash-wrapper">
      <div className="flash-sale-banner">
        <img src={banner_image} alt="flash-sale-banner" />
      </div>

      <div className="flash-data-container">
        <div className="flash-left">
          <div className="flash-left-img">
            <img src={icon} alt="icon" />
          </div>
          <div className="flash-left-data">
            <div className="flash-left-data-header">{name}</div>
            <div className="flash-left-data-descript">{package_name}</div>
          </div>
        </div>

        <div className="flash-right">
          <div className="flash-right-data">
            <div className="flash-right-data-price">
              <img src={images.flash_sale_whitebg} alt="white-background" />
              <div className="flash-sale-price-data">{amount_message}</div>
            </div>
            <div className="flash-right-data-descript">{flashsale_message}</div>
          </div>
          <div
            className="flash-right-button"
            onClick={() =>
              navigateFromUserDashboardBanner(
                history,
                `/package/${package_id}`
              )
            }
          >
            {button_text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashSale;
